import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import MobileStoreButton from '@r1-frontend/ui-react/components/buttons/mobileStoreButton/index';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

const breakePoints = {
    desktop: '1600px',
    sDesktop: '1187px',
    tablet: '859px',
    mobile: '640px',
};

export const WatchEverywhere = styled.div`
    box-sizing: border-box;
    width: 100%;
    margin-bottom: -50px;
    padding-bottom: 40px;
    background-color: ${COLORS.white};

    @media (max-width: ${breakePoints.tablet}) {
        margin-top: 50px;
    }
`;

export const Section = styled.div`
    display: block;
    width: 100%;
    padding-top: 90px;
    background-color: ${COLORS.white};

    @media (max-width: ${breakePoints.mobile}) {
        padding-top: 70px;
    }
`;

export const TopSection = styled(Section)`
    padding-top: 40px;
`;

export const ContentWrap = styled(GridContainer)`
    display: flex;
    flex-wrap: nowrap;

    @media (max-width: ${breakePoints.mobile}) {
        flex-wrap: wrap;
        width: 100%;
        order: -1;
    }
`;

export const TopButton = styled(BaseButton)`
    margin-top: 20px;
    width: auto;

    @media (max-width: ${breakePoints.mobile}) {
        width: 100%;
    }
`;

export const Description = styled.div`
    display: flex;
    flex-direction: column;
    padding: 40px 0;
`;

export const TopDescription = styled(Description)`
    flex: 0 0 53%;
    width: 53%;
    justify-content: center;
    align-items: flex-start;

    @media (max-width: ${breakePoints.mobile}) {
        flex: 0 0 100%;
        width: 100%;
    }
`;

export const ImageWrap = styled.div`
    display: flex;
    align-items: center;

    @media (max-width: ${breakePoints.mobile}) {
        order: -1
    }
`;

export const Img = styled.img`
    max-width: 500px;
    width: 100%;
    height: auto;
    object-fit: contain;
`;

export const PageTitle = styled.h1`
    margin-top: 0;
    margin-bottom: 12px;
    width: 100%;
    ${FONTS.H2};

    @media (max-width: ${breakePoints.sDesktop}) {
        ${FONTS.H1};
    }
`;

export const SectionTitle = styled.h2`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 70px;
    ${FONTS.H1};

    @media (max-width: ${breakePoints.sDesktop}) {
        margin-bottom: 50px;
        ${FONTS.H2};
    }
`;

export const Text = styled.div`
    margin-bottom: 0;
    width: 100%;
    ${FONTS.L};
    white-space: pre-wrap;

    p {
      margin-bottom: 20px;
    }

    @media (max-width: ${breakePoints.desktop}) {
      white-space: normal;
    }
`;

export const GrayText = styled(Text)`
    text-align: center;
    margin-top: 28px;
    color: ${COLORS.black};
    ${FONTS.L};
`;

export const CardList = styled.ul`
    display: flex;
    flex-wrap: nowrap;
    width: 100%;

    @media (max-width: ${breakePoints.sDesktop}) {
        flex-direction: column;
    }
`;

export const CardItem = styled.li`
    flex: 0 1 33.3%;
    display: flex;
    justify-content: center;
    border-right: 2px solid rgba(0,0,0,.05);

    &:last-child {
        border-right: none;
    }

    @media (max-width: ${breakePoints.sDesktop}) {
        flex: 0 1 auto;
        border-right: none;
        margin-right: 0;
        margin-bottom: 50px;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const TariffCardItem = styled(CardItem)`
    border-right: none;
    margin-right: 15px;

    &:last-child {
        margin-right: 0;
    }
`;

export const PopupWrap = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 1080px;
    padding: 60px;
    background-color: ${p => p.hasBackColor ? COLORS.lightGrey : 'transparent'};

    @media (max-width: ${breakePoints.sDesktop}) {
        max-width: 910px;
    }

    @media (max-width: ${breakePoints.tablet}) {
        padding: 60px 50px;
    }

    @media (max-width: ${breakePoints.mobile}) {
        padding: 40px 30px;
    }
`;

export const PopupTitle = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    text-align: center;
    ${FONTS.H2};
    @media (max-width: ${breakePoints.tablet}) {
        ${FONTS.H3};
    }
    @media (max-width: ${breakePoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const PopupContent = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;

    @media (max-width: ${breakePoints.sDesktop}) {
        flex-direction: column;
        max-width: 600px;
    }
`;

export const PopupText = styled.div`
    display: flex;
    justify-content: center;
    text-align: center;
    ${FONTS.XS};
    margin-top: 30px;
`;

export const PopupRow = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 30px;
`;

export const A = styled.a`
    margin: 0 5px;
    text-decoration: underline;
`;

export const StoreButton = styled(MobileStoreButton)`
    width: 140px;
    margin: 10px 25px;

    &:first-child {
        margin-right: 25px;
    }
`;

export const PopupButton = styled(BaseButton)``;
